import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';

/**
 * Lista de preguntas/respuestas con el estilo "tarjeta que abre al pasar el
 * ratón". La comparten HomeSellingFaq (dos columnas, sin título) y HomeThreeFaq
 * (una columna junto a su columna de texto), así que el estilo y el
 * comportamiento se mantienen idénticos en los dos bloques desde un solo sitio.
 *
 *  - Hover: `onPointerEnter/Leave` filtrando `pointerType === 'mouse'`, para que
 *    en táctil (donde el toque emula un mouseenter) no se abra y se cierre de
 *    golpe. En táctil y con teclado se abre con clic/Enter, que además FIJA la
 *    respuesta: en ratón, un clic la deja abierta aunque salgas de la tarjeta.
 *  - `idPrefix` distinto por bloque: los dos viven en la misma página y los
 *    `id`/`aria-controls` no pueden repetirse.
 *
 * items: [{ key, question, answer }]
 */
const HoverFaqList = ({ items, columns = 2, idPrefix = 'hsf' }) => {
  const [hoverKey, setHoverKey] = useState(null);
  const [pinnedKey, setPinnedKey] = useState(null);

  const isOpen = (key) => pinnedKey === key || hoverKey === key;

  const enter = (key) => (e) => {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    setHoverKey(key);
  };
  const leave = (e) => {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    setHoverKey(null);
  };
  const toggle = (key) => () => setPinnedKey((prev) => (prev === key ? null : key));

  return (
    <div className={`hsf__grid hsf__grid--${columns}`}>
      {items.map((item) => {
        const open = isOpen(item.key);
        const answerId = `${idPrefix}-answer-${item.key}`;
        return (
          <article
            className={`hsf__item${open ? ' is-open' : ''}`}
            key={item.key}
            onPointerEnter={enter(item.key)}
            onPointerLeave={leave}
          >
            <button
              type="button"
              className="hsf__question"
              onClick={toggle(item.key)}
              onFocus={() => setHoverKey(item.key)}
              onBlur={() => setHoverKey(null)}
              aria-expanded={open}
              aria-controls={answerId}
            >
              <span>{item.question}</span>
              <FiPlus className="hsf__icon" aria-hidden="true" />
            </button>
            <div className="hsf__answer" id={answerId} role="region">
              <div>
                <p>{item.answer}</p>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default HoverFaqList;
